import React from 'react';
import {
  LegendContainer,
  LegendList,
  LegendItem,
  Swatch,
  LegendText,
} from './Legend.styled';

export interface LegendDataItem {
  label: string;
  intent: 'success' | 'warning' | 'danger' | 'default';
}

interface ILegendProps {
  description?: string;
  data: LegendDataItem[];
}

export function Legend ({ description, data }: ILegendProps) {
  const getIntentColor = (intent: string) => {
    switch (intent) {
      case 'success':
        return '#4fada6';
      case 'warning':
        return '#f2cb15';
      case 'danger':
        return '#ef374e';
      case 'default':
        return '#d9d9d9';
      default:
        return '#d9d9d9';
    }
  };

  return (
    <LegendContainer>
      {description && <div>{description}</div>}
      <LegendList>
        {data.map((item, index) => (
          <LegendItem key={index}>
            <Swatch style={{ backgroundColor: getIntentColor(item.intent) }} />
            <LegendText>{item.label}</LegendText>
          </LegendItem>
        ))}
      </LegendList>
    </LegendContainer>
  );
}
